module.exports = __webpack_public_path__ + "img/profile.1a0433cb.png";